import { ForwardedRef, forwardRef } from 'react';
import { MemoryRouter, Route, Switch, useLocation } from 'react-router-dom';
import * as Dialog from 'components/dialog';
import { PromptPage } from 'components/recommended-actions/plus-prompt-dialog-content/PromptPage';
import { TrialForm } from 'components/recommended-actions/plus-prompt-dialog-content/TrialForm';
import { TrialRegistrationComplete } from 'components/recommended-actions/plus-prompt-dialog-content/TrialRegistrationComplete';
import { twMerge } from 'tailwind-merge';

interface RecommendedActionsPlusDialogProps extends Dialog.DialogProps {}
const RecommendedActionsPlusDialog = ({ children, ...rest }: RecommendedActionsPlusDialogProps) => {
    return (
        <Dialog.Root {...rest}>
            {children}
            <MemoryRouter initialEntries={['/prompt']}>
                <Dialog.Portal>
                    <Dialog.Overlay />
                    <Dialog.Title>Start your free Plus trial</Dialog.Title>
                    <DialogContentWithLocationStyling>
                        <Switch>
                            <Route path={'/prompt'} component={PromptPage} />
                            <Route path={'/form'} component={TrialForm} />
                            <Route path={'/complete'} component={TrialRegistrationComplete} />
                        </Switch>
                    </DialogContentWithLocationStyling>
                </Dialog.Portal>
            </MemoryRouter>
        </Dialog.Root>
    );
};

interface DialogContentWithLocationStylingProps extends Dialog.DialogContentProps {}
const DialogContentWithLocationStyling = forwardRef(
    (
        { children, ...rest }: DialogContentWithLocationStylingProps,
        forwardedRef: ForwardedRef<HTMLDivElement>,
    ) => {
        const location = useLocation();

        return (
            <Dialog.Content
                ref={forwardedRef}
                className={twMerge(
                    'transition-[max-width] duration-300 ease-in-out',
                    location.pathname === '/prompt' && 'w-[92vw] max-w-[53rem] p-0',
                    (location.pathname === '/form' || location.pathname === '/complete') && 'p-8',
                )}
                {...rest}
            >
                {children}
            </Dialog.Content>
        );
    },
);

const RecommendedActionsPlusDialogTrigger = Dialog.Trigger;

const Root = RecommendedActionsPlusDialog;
const Trigger = RecommendedActionsPlusDialogTrigger;

export {
    RecommendedActionsPlusDialog,
    RecommendedActionsPlusDialogTrigger,
    //
    Root,
    Trigger,
};
